import React, { useState } from "react";
import "./project8.css";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import PathfinderImg from "./images/PathfinderImg.png";
import App from "./App";

function Project8() {
  const [main, setMain] = useState(false);
  const gotoMainPage = () => {
    setMain(true);
  };

  return (
    <>
      {!main ? (
        <div className="body">
          <div className="headerP1">
            <h2 id="Title">A* Pathfinding Visualizer</h2>
            <div id="P1Github">
              <a
                href="https://github.com/AkhilTheBoss/PathFinder"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="secondary">Github</Button>
              </a>
            </div>
            <div id="mainPage">
              <Button variant="primary" onClick={gotoMainPage}>
                Main Page
              </Button>
            </div>
          </div>
          <br />
          <h4 className="Heading">Introduction</h4>
          <p className="Content">
            Developed an application using the A* search algorithm to find the
            shortest distance between two nodes in a grid.
          </p>
          <h4 className="Heading">Diagram</h4>
          <p className="Content">
            <img src={PathfinderImg} alt="Path" className="Diagram4" />
          </p>
          <h4 className="Heading">Explanation</h4>
          <p className="Content">
            <div>
              I've implemented an A* pathfinding algorithm using Python's pygame
              module. The application is designed around a 50x50 grid where
              users can designate a start node (orange color node) and an end
              node (turquoise color node). Additionally, users have the option
              to place barriers (black color node) within the grid.
            </div>
            <p>The A* algorithm evaluates nodes based on three scores:</p>
            <ul>
              <li>
                G Score: This represents the distance from the selected node to
                the starting node.
              </li>
              <li>
                H Score: It's a heuristic that estimates the distance from the
                end node to the selected node.
              </li>
              <li>
                F Score: The F score is the sum of the G score and the H score
                (F = G + H).
              </li>
            </ul>
            <div>
              When a node is selected, all its neighbors are marked as green
              (indicating all those nodes are being considered). The green node
              with the shortest F score is then chosen as the next selected node
              and the selected node is marked red. If there are multiple nodes
              with the same shortest F score, the one with the shortest H score
              takes precedence. The start node is the initial selected node.
            </div>
            <div>
              When a node is selected, all its neighbors are marked as green
              (indicating consideration). The green node with the shortest F
              score is then chosen as the next selected node. If there are
              multiple nodes with the same shortest F score, the one with the
              shortest H score takes precedence.
            </div>
            <div>
              Once the algorithm successfully reaches the end node, it
              backtracks through the grid, marking the path with yellow nodes
              based on the stored dictionary information. This pathfinding
              process helps users find the optimal route from the start node to
              the end node within the grid.
            </div>
          </p>
          <h4 className="Heading">Scope For Improvement</h4>
          <p className="Content">
            <ul>
              <li>
                User Interface (UI) Enhancements: Improve the user interface to
                make it more intuitive and user-friendly. Provide a clear user
                guide or tooltips to explain how to use the application.
              </li>
              <li>
                Multiple Pathfinding Algorithms: Include support for other
                pathfinding algorithms (e.g., Dijkstra's algorithm, BFS) to give
                users more options.
              </li>
            </ul>
          </p>
        </div>
      ) : (
        <App />
      )}
    </>
  );
}

export default Project8;
